import TablePasajeros from "../../components/Tablepasajeros";
import TableVehiculo from "../../components/TableVehiculo";
import GridStructure from "../../components/GraficaRuta";
import Sider from "../../components/siderbarcomponents.jsx";


export default function Dashboard() {
  return (
    <div className="flex h-screen bg-gray-100">
        <Sider />

        <div className="flex flex-col p-10 justify-between w-full">

            <div className="flex w-full justify-between h-[58%] "> 
                <div className="w-[60%]">
                <TableVehiculo />
                </div>
                <div className="w-[38%]">
                <TablePasajeros />
                </div>                       
            </div>

            <div className="h-[4%] flex items-center justify-center w-full bg-white">
          <div className="flex justify-between w-full p-2">
            <div className="w-[5%] mr-6">
              <h2 className="text-[12px] text-textTipic font-medium ">
                Hilometros
              </h2>
            </div>
            <div className="flex justify-around w-[90%] ">
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km2</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km4</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km6</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km8</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km10</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km12</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km14</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km16</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km18</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km20</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km22</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km26</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km28</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km30</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km32</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km34</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km36</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km38</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km40</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km42</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km44</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km46</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km48</h2>
              <h2 className="flex-1 text-[12px] text-textTipic font-medium text-center">Km50</h2>
            </div>
            <div className="w-[5%] ">
              <h2></h2>
            </div>
          </div>
        </div>
            
            <div className="w-full h-[34%] bg-white">
                <GridStructure />
            </div>  



        </div>
        
          
      
    </div>
  );
}
